import { Store } from '@tanstack/react-store';
import type { SortingState } from '@tanstack/react-table';
import { createManagementActions } from './createManagementStore';

export interface AuditDetail {
  id: string;
  userId: string | null;
  action: string;
  entityType: string | null;
  entityId: string | null;
  changes: Record<string, unknown>;
  metadata: Record<string, unknown> | null;
  status: 'success' | 'failure' | 'pending';
  error: string | null;
  duration: number | null;
  createdAt: number;
  user: {
    id: string;
    email: string;
    fullName: string;
  } | null;
}

interface AuditManagementState {
  audits: AuditDetail[];
  filters: {
    status: 'all' | 'success' | 'failure' | 'pending';
    actions: string[];
    entityTypes: string[];
    entityId: string;
    userId: string;
    search: string;
    startDate: string;
    endDate: string;
  };
  sorting: SortingState;
  pagination: {
    currentPage: number;
    totalPages: number;
    total: number;
  };
  ui: {
    isLoading: boolean;
    selectedAuditId: string | null;
  };
}

export type AuditFilters = AuditManagementState['filters'];

const initialFilters: AuditManagementState['filters'] = {
  status: 'all',
  actions: [],
  entityTypes: [],
  entityId: '',
  userId: '',
  search: '',
  startDate: '',
  endDate: '',
};

const defaultSorting: SortingState = [{ id: 'timestamp', desc: true }];

export const auditManagementStore = new Store<AuditManagementState>({
  audits: [],
  filters: initialFilters,
  sorting: defaultSorting,
  pagination: { currentPage: 1, totalPages: 1, total: 0 },
  ui: { isLoading: true, selectedAuditId: null },
});

const actions = createManagementActions(auditManagementStore, {
  initialFilters,
  defaultSorting,
});

export const {
  updateFilter,
  setSorting,
  setPage,
  setPaginationInfo,
  setLoading,
  resetFilters,
} = actions;

export const setAudits = (audits: AuditDetail[]) => {
  auditManagementStore.setState((prev) => ({ ...prev, audits }));
};

export const selectAudit = (auditId: string | null) => {
  actions.setUiField('selectedAuditId', auditId);
};
